import React from 'react';
import { Tooltip as ShadcnTooltip, TooltipTrigger, TooltipContent } from '../../shadcn/tooltip';

const Tooltip = ({ children, content, side = "top", sideOffset = 8, align = "center", className = "" }) => {
  return (
    <ShadcnTooltip>
      <TooltipTrigger asChild>
        {children}
      </TooltipTrigger>
      <TooltipContent
        side={side}
        sideOffset={sideOffset}
        align={align}
        className={`bg-black text-white rounded-lg p-3 text-sm border-0 shadow-lg ${className}`}
      >
        {content}
      </TooltipContent>
    </ShadcnTooltip>
  );
};

export default Tooltip;